import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };

    }

    // this will be deprecated in a future release
    // Use static getDerivedStateFromError() to handle fallback rendering instead.
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        console.log('React crash error: ', error);
        console.log('React crash info -- which component threw an arror : ', info?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className={'d-flex flex-column justify-content-center align-items-center w-100'}>
                    <h1>Oops...</h1>
                    <h2>Something went wrong.</h2>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
